import React from 'react';
import { compose } from 'ramda';
import { connect } from 'react-redux';
import STSummaryBanner from './StarTraveler/SummaryBanner'
import {STAR_TRAVELER_CODE} from '@synergycms_app/store/customer/loyaltyActions'

const LoyaltySummaryBanner = props => {

    const {type } = props;
    if(type === STAR_TRAVELER_CODE) {
      return (<STSummaryBanner {...props} />);
    }

    return null;
};

const mapStateToProps = (store, ownProps) => {
  
  const loyalty = store.getIn(["customer", "loyalty", "data", "loyalty"]);
  return {
    loyalty,
    type: loyalty && loyalty.get("code")
  }
};
  

export default compose(
  connect(
    mapStateToProps,
  ),
)(LoyaltySummaryBanner);
